<template>
    <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
        <v-dialog v-model="dialog" persistent width="500">
            <v-card>
                <v-toolbar color="primary" dark flat dense cad>
                    <v-toolbar-title class="subheading">{{labeldialog}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closedialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="text-xs-left">
                    <v-form ref="form" lazy-validation>
                                <v-col cols="12" md="12 ">
                                    <v-select
                                            label="Bank"
                                            item-text="bankname"
                                            item-value="bank"
                                            v-model="editbank.bank"
                                            :items="banks"
                                    ></v-select>
                                    <v-text-field label="Nomor Rekening" name="name" v-model="editbank.accountno"></v-text-field>
                                    <v-text-field label="Nama Pemilik Rekening" name="name" v-model="editbank.accountname"></v-text-field>
                                    <v-text-field label="OTP" name="otp" v-model="editbank.otp"></v-text-field>
                                    <v-btn @click="sendOtp" color="primary">
                                        <v-icon dark>send</v-icon> REQUEST OTP
                                    </v-btn>
                                </v-col>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text dark @click="closedialog" color="red">Tutup</v-btn>
                    <v-btn text dark @click="save" color="green">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-toolbar elevation="0">
            <v-text-field
                    flat
                    solo
                    prepend-icon="search"
                    placeholder="Type something"
                    v-model="search"
                    hide-details
                    class="hidden-sm-and-down"
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-btn class="ml-2" color="primary" @click.native="addnewbank">
                <v-icon dark>add</v-icon>Tambah Rekening Bank
            </v-btn>
            <v-btn class="ml-2" color="primary" @click.native="getWallet(opsitablebank)">
                <v-icon dark>refresh</v-icon>Refresh
            </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table
                :headers="headers"
                :search="search"
                :items="walletbanks"
                class="elevation-0"
                item-key="id"
                :options.sync="opsitablebank"
                :server-items-length="total_walletbank"
                :loading="loading"
                @update:options="getWallet(opsitablebank)"
        >
            <template v-slot:item.actions="{ item }">
                <div class="ma-4 text-xs-left">
                    <v-btn @click.native="deleteItem(item)" icon small>
                        <v-icon color="pink">delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import moment from "moment";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "Banks",
        data: ()=>({
            search: '',
            menu1: false,
            menu2: false,
            total: 0,
            labeldialog: "Tambah Rekening",
            dateawal: moment().add(7,'hours').toISOString().substr(0, 10),
            dateakhir: moment().add(7,'hours').toISOString().substr(0, 10),
            banks: [
                {
                    id: "1",
                    bank: 'BCA',
                    bankname: 'BCA'
                },
                {
                    id: "2",
                    bank: 'MANDIRI',
                    bankname: 'Mandiri'
                },
                {
                    id: "3",
                    bank: 'BNI',
                    bankname: 'BNI'
                },
                {
                    id: "4",
                    bank: 'BRI',
                    bankname: 'BRI'
                }
            ],
            editbank: {
                bankid:1,
                bank :"BCA",
                accountno: "",
                accountname: "",
                otp: ""
            },
            opsitablebank: {
                search:'',
                itemsPerPage: 10,
                page:1,
                sortBy: ["id"],
                awal: moment().add(7,'hours').toISOString().substr(0, 10),
                akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            },
            headers: [
                {
                    text: 'id',
                    value: 'id'
                },
                {
                    text: 'Bank',
                    value: 'bank'
                },
                {
                    text: 'No Rekening',
                    value: 'accountno'
                },
                {
                    text: 'Nama Rekening',
                    value: 'accountname'
                },
                {
                    text: 'Aksi',
                    value: 'actions'
                }
            ],
        }),
        computed: {
            ...mapState('Wallet',['walletbanks','total_walletbank','dialog','loading'])
        },
        methods: {
            ...mapActions('Wallet',['getWallet','deleteWalletbank','opendialog','closedialog','addWalletbank','getOtp']),
            addnewbank (){
                this.editbank= {
                    bankid:1,
                    bankname : 'BCA',
                    accountno: '',
                    accountname: '',
                    otp: ''
                }
                this.opendialog();
            },
            save(){
                this.addWalletbank(this.editbank);
                // console.log(this.editbank)
            },
            sendOtp(){
              this.getOtp("add_bank")
            },
            openFormEdit(data){
                this.editbank=data;
                this.opendialog();
            },
            deleteItem(data) {
                this.delete_id = data.id
                this.$confirm('Yakin akan hapus '+data.bank+' '+data.accountno+'?', { color: 'red',title:'Hapus',icon:'fa-danger' }).then(res => {
                    if (res) {
                        this.deleteWalletbank(this.delete_id)
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
